import LibraryModel from './models/library';
import LibraryCollection from './collections/libraries';
import LayoutView from './views/layout.js';
import SelectView from './views/select_autocomplete_box';
import CompleteListView from './views/complete_list';

const createComponent = ({target}) => {
    const model = new LibraryModel();
    const collection = new LibraryCollection();
    const layoutView = new LayoutView({target, model, collection}); // eslint-disable-line no-unused-vars
    const selectView = new SelectView({target, model, collection}); // eslint-disable-line no-unused-vars
    const completeListView = new CompleteListView({target, model, collection}); // eslint-disable-line no-unused-vars

    collection.fetch();
};

export default createComponent;
